import { motion } from 'framer-motion';
import type { MachineCategoryData } from '@/pages/Maschinenpark';
import { MachineCard } from '@/components/sections/MachineCard';

interface MachineCategoryProps {
  category: MachineCategoryData;
  index: number;
}

export function MachineCategory({ category, index }: MachineCategoryProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
    >
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <category.icon className="w-6 h-6 text-primary" />
        </div>
        <h2 className="text-3xl font-bold">{category.category}</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {category.items.map((machine, i) => (
          <MachineCard key={machine.name} machine={machine} index={i} />
        ))}
      </div>
    </motion.div>
  );
}
